import { Collection } from 'modules/core/lib/mobx-rest'

import Notifier from 'modules/notifications/store/models/Notifier'

class Notifiers extends Collection<Notifier> {
  get cacheKey(): string {
    return 'notifiers'
  }

  model() {
    return Notifier
  }
}

export default new Notifiers()
